//import mindPart from '../assets/mind.png';
//import teckPart from '../assets/teck.png';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from './../components/Context/UserContext';
import CountUp from 'react-countup';
import ReactApexChart from 'react-apexcharts';
import '../styles/MasterPage.css';
import AppLayout from './AppLayout';
// ─── Approval status buckets (from InvoiceInfoController) ────────────────────
const APPROVED_STATUSES = [11];
const IN_PROGRESS_STATUSES = [2, 3, 4, 5, 9, 14, 20];
function MasterPage() {
    const { user } = useUser();
    console.log("DEBUG USER:", user);
    console.log("DEBUG userTypeIds:", JSON.stringify(user?.userTypeIds));
    const location = useLocation();
    const navigate = useNavigate();
    // ── is this a vendor session? ─────────────────────────────────────────────
    const isVendor = Array.isArray(user?.userTypeIds) && user.userTypeIds.includes(25);
    /*const [invoiceChartData, setInvoiceChartData] = useState(Array(6).fill(0));*/
    const [vendorList, setVendorList] = useState([]);
    const [vendorLoading, setVendorLoading] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [loading, setLoading] = useState(true);
    const [darkMode, setDarkMode] = useState(() => {
        try { return localStorage.getItem('darkMode') === 'true'; } catch { return false; }
    });
    const [pendingVendors, setPendingVendors] = useState([]);
    const [pendingInvoicesAdmin, setPendingInvoicesAdmin] = useState([]);
    const [pendingInvoices, setPendingInvoices] = useState([]);
    const [pendingInvoicesperUser, setPendingInvoicesperUser] = useState([]);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [isModalClosing, setIsModalClosing] = useState(false);
    const modalRef = useRef(null);
    const [usersList, setUsersList] = useState([]);
    const [showWelcome, setShowWelcome] = useState(false);
    const [animationPhase, setAnimationPhase] = useState('initial');
    const [vendorChartData, setVendorChartData] = useState(Array(12).fill(0));
    const [invoiceSeries, setInvoiceSeries] = useState([]);
    const [invoiceCategories, setInvoiceCategories] = useState([]);
    const [invoicePage, setInvoicePage] = useState(1);
    const invoicesPerPage = 10;
    const [approvalPage, setApprovalPage] = useState(1);
    const approvalsPerPage = 10;
    const [usersPage, setUsersPage] = useState(1);
    const usersPerPage = 10;
    const [vendorsPage, setVendorsPage] = useState(1);
    const vendorsPerPage = 10;
    //const [invoiceChartData, setInvoiceChartData] = useState({
    //    approved: Array(6).fill(0),
    //    pending: Array(6).fill(0)
    //});
    const [stats, setStats] = useState({
        totalVendors: 0, totalUsers: 0,
        VendorsPendingFinalApproval: 0, InvoicesPendingApproval: 0, activeContracts: 0,
    });
    // ── vendor stats ──────────────────────────────────────────────────────────
    const [vendorStats, setVendorStats] = useState({
        totalCreated: 0, approved: 0, inProgress: 0,
    });

    const [vendorCompany, setVendorCompany] = useState('');
    const [vendorInvoiceList, setVendorInvoiceList] = useState([]);
    const [myInvoicesPage, setMyInvoicesPage] = useState(1);
    const [myApprovedPage, setMyApprovedPage] = useState(1);
    const myInvoicesPerPage = 10;
    // ── fetch admin dashboard stats ───────────────────────────────────────────
    useEffect(() => {

        if (isVendor) return;
        const fetchDashboardData = async () => {
            try {
                setLoading(true);

                const empId = user?.empId;  // only dept head/verifier have this
                const userTypeIds = user?.userTypeIds || [];
                console.log("PENDING-APPROVAL PARAMS:", { empId, userTypeIds: JSON.stringify(userTypeIds) });
                console.log('Taking path:', empId ? 'DEPT HEAD/VERIFIER' : 'ADMIN/ORIGINAL');

                if (empId) {
                    // ── Dept Head / Verifier ──────────────────────
                    const response = await axios.get(
                        '/api/totalvendor/total-vendors-and-users',                      
                        {
                            params: empId ? {
                                userId: empId,
                                userTypeIds: userTypeIds.join(',')  // e.g. "2,15"
                            } : {}
                        }
                    );
                    setStats({
                        totalVendors: response.data.totalVendors || 0,
                        totalUsers: response.data.totalUsers || 0,
                        VendorsPendingFinalApproval: response.data.pendingApprovals || 0,
                        InvoicesPendingApproval: response.data.recentOrders || 0,
                        activeContracts: response.data.activeContracts || 0,
                    });
                } else {

                    // ── Everyone else — original untouched logic ──
                    const response = await axios.get(
                        '/api/totalvendor/total-vendors-and-user'
                    );
                    setStats({
                        totalVendors: response.data.totalVendors || 0,
                        totalUsers: response.data.totalUsers || 0,
                        pendingApprovals: response.data.pendingApprovals || 0,
                        recentOrders: response.data.recentOrders || 0,
                        activeContracts: response.data.activeContracts || 0,
                    });
                }

            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchDashboardData();
        const interval = setInterval(fetchDashboardData, 30000);
        return () => clearInterval(interval);
    }, [isVendor, user]);

    useEffect(() => {
        const fetchInvoiceChartData = async () => {
            try {
                const res = await axios.get(
                    "/api/invoices/approval-chart"
                );
                const approvedData = [];
                const pendingData = [];
                const categories = [];
                if (Array.isArray(res.data)) {
                    res.data.forEach(item => {
                        approvedData.push(item.approved);
                        pendingData.push(item.pending);
                        // ✅ convert month number → month name
                        const monthName = new Date(0, item.month - 1)
                            .toLocaleString('default', { month: 'short' });
                        categories.push(monthName);
                    });
                }
                setInvoiceSeries([
                    { name: 'Approved Invoices', data: approvedData },
                    { name: 'Pending Invoices', data: pendingData }
                ]);
                setInvoiceCategories(categories);
            } catch (err) {
                console.error("Invoice chart error:", err);
            }
        };
        fetchInvoiceChartData();
    }, []);
   
        useEffect(() => {
            const fetchPending = async () => {
                try {
                    const empId = user?.empId;
                    const userTypeIds = user?.userTypeIds || [];
                    const res = await axios.get("/api/invoices/pending-final-approval", {
                        params: empId ? { userId: empId, userTypeIds: userTypeIds.join(',') } : {}
                    });
                    console.log("PENDING DATA:", res.data);
                    setPendingVendors(res.data || []);
                } catch (err) {
                    console.error("Pending approval error:", err);
                }
            };
            fetchPending();
        }, [user]);  

    useEffect(() => {
        const fetchPendingInvoicesAdmin = async () => {
            try {
                const empId = user?.empId;
                const userTypeIds = user?.userTypeIds || [];
                const res = await axios.get("/api/invoices/pending-approval-count", {
                    params: empId ? { userId: empId, userTypeIds: userTypeIds.join(',') } : {}
                });
                setPendingInvoicesAdmin(res.data || []);
            } catch (err) {
                console.error("Pending invoice (admin) error:", err);
            }
        };
        fetchPendingInvoicesAdmin();
    }, [user]);

    useEffect(() => {
        if (!isVendor || !user) return;
        const userId =
            user?.ID ||
            user?.id ||
            user?.user?.id ||
            user?.selectedCompany?.id ||
            sessionStorage.getItem('userId');

        const fetchPendingInvoicesperUser = async () => {
            try {
                const res = await axios.get(
                    `/api/invoice/pending-approval-user/${userId}`
                );
                console.log("PENDING INVOICES:", res.data);
                setPendingInvoicesperUser(res.data || []);
            } catch (err) {
                console.error("Pending invoice error:", err);
            }
        };
        fetchPendingInvoicesperUser();
    }, []);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const empId = user?.empId;
                const userTypeIds = user?.userTypeIds || [];

                if (empId) {
                    const res = await axios.get("/api/vendordetails/vendor-list", {
                        params: { empId, userTypeIds: userTypeIds.join(',') }
                    });
                    const mapped = (res.data || []).map(v => ({
                        nameOfCompany: v.nameOfCompany,
                        contactNumber: v.contactNumber,
                        createDate: v.startDate ?? v.createDate
                    }));
                    setUsersList(mapped);
                } else {
                    const res = await axios.get("/api/userregistration/summary");
                    setUsersList(res.data || []);
                }
            } catch (err) {
                console.error("User summary error:", err);
            }
        };
        fetchUsers();
    }, [user]);
    useEffect(() => {
        if (!isVendor || !user) return;
        const userId =
            user?.ID ||
            user?.id ||
            user?.user?.id ||
            user?.selectedCompany?.id ||
            sessionStorage.getItem('userId');

        const fetchVendorData = async () => {
            setLoading(true);
            try {
                let company = user?.NameOfCompany || user?.nameOfCompany || '';
                if (!company) {
                    const { data: userDetail } = await axios.get(
                        `/api/vendors/userdetails/${userId}`
                    );
                    company =
                        userDetail?.nameOfCompany ||
                        userDetail?.NameOfCompany ||
                        '';
                }
                setVendorCompany(company);
                const { data: invoiceData } = await axios.get(
                    '/api/invoices/all-summary',
                    { params: { page: 1, pageSize: 1000 } }
                );
                const all = invoiceData?.data ?? [];
                const mine = company
                    ? all.filter((inv) => inv.companyName === company)
                    : all;
                setVendorStats({
                    totalCreated: mine.length,
                    approved: mine.filter((inv) =>
                        APPROVED_STATUSES.includes(inv.approvalStatus)
                    ).length,
                    inProgress: mine.filter((inv) =>
                        IN_PROGRESS_STATUSES.includes(inv.approvalStatus)
                    ).length,
                });

                setVendorInvoiceList(mine);
                const { data: pendingData } = await axios.get(
                    "/api/invoice/pending-approval",
                    { params: userId ? { userId } : {} }
                );
                setPendingInvoices(pendingData || []);

            } catch (err) {
                console.error('Vendor stats fetch error:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchVendorData();
        const interval = setInterval(fetchVendorData, 30000);
        return () => clearInterval(interval);
    }, [isVendor, user]);

    useEffect(() => {
        //if (!isVendor || !user) return;
        const fetchVendorChartData = async () => {
            try {
                const res = await axios.get(
                    "/api/vendordetails/vendor-activity"
                );
                const monthMap = Array(12).fill(0);
                if (Array.isArray(res.data)) {
                    res.data.forEach(item => {
                        const monthIndex = item.month - 1;
                        if (monthIndex >= 0 && monthIndex < 12) {
                            monthMap[monthIndex] = item.count;
                        }
                    });
                }
                setVendorChartData(monthMap);
            } catch (err) {
                console.error("Chart API error:", err);
            }
        };
        fetchVendorChartData();
    }, [isVendor, user]);
    // ── dark mode ─────────────────────────────────────────────────────────────
    useEffect(() => {
        document.body.classList.toggle('dark-mode', darkMode);
        document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
        localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);
    // ── keep charts in sync with the shell's dark-mode toggle ─────────────────
    useEffect(() => {
        const handler = (e) => setDarkMode(!!e.detail);
        window.addEventListener('vms:darkmode', handler);
        return () => window.removeEventListener('vms:darkmode', handler);
    }, []);
    // ── scroll lock when modal open ───────────────────────────────────────────
    useEffect(() => {
        document.body.style.overflow = selectedDetail ? 'hidden' : 'auto';
        return () => { document.body.style.overflow = 'auto'; };
    }, [selectedDetail]);
    // ── modal a11y: ESC to close + focus trap ─────────────────────────────────
    useEffect(() => {
        if (!selectedDetail) return;
        const modalEl = modalRef.current;
        // Move focus into the dialog on open.
        const focusables = () =>
            modalEl
                ? Array.from(
                    modalEl.querySelectorAll(
                        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                    )
                ).filter(el => !el.disabled && el.offsetParent !== null)
                : [];
        const first = focusables()[0];
        if (first) first.focus();
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                closeModal();
                return;
            }
            if (e.key === 'Tab') {
                const items = focusables();
                if (items.length === 0) return;
                const firstEl = items[0];
                const lastEl = items[items.length - 1];
                if (e.shiftKey && document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                } else if (!e.shiftKey && document.activeElement === lastEl) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDetail]);
    // ── helpers ───────────────────────────────────────────────────────────────
    const toggleSidebar = () => setSidebarOpen(s => !s);
    const handleImageClick = () => setShowCard(s => !s);
    const toggleDarkMode = () => setDarkMode(d => !d);
    const toggleExpand = menuId => setExpandedMenus(prev => ({ ...prev, [menuId]: !prev[menuId] }));
    /*const handleCardClick = type  => setSelectedDetail(type);*/
    const handleCardClick = async (type) => {
        console.log("Clicked:", type);
        setSelectedDetail(type);
        // RESET PAGE WHEN OPENING INVOICE MODAL
        if (type === 'invoicePending') {
            setInvoicePage(1);
        }
        if (type === 'approvals') {
            setApprovalPage(1);
        }
        if (type === 'users') {
            setUsersPage(1);
        }
        if (type === 'vendors') {
            setVendorsPage(1);
        }
        if (type === 'totalCreated') {
            setMyInvoicesPage(1);
        }
        if (type === 'approvedInvoices') {
            setMyApprovedPage(1);
        }

        if (type === 'vendors') {
            setVendorLoading(true);
            try {
                const empId = user?.empId;
                const userTypeIds = user?.userTypeIds || [];
                const res = await axios.get("/api/vendordetails/vendor-list", {
                    params: empId ? { empId, userTypeIds: userTypeIds.join(',') } : {}
                });
                setVendorList(res.data || []);
            } catch (err) {
                console.error("FULL ERROR:", err);
                setVendorList([]);
            } finally {
                setVendorLoading(false);
            }
        }
    };
    const closeModal = () => {
        // Play the fade-out animation (120ms) before unmounting — keeps logic intact.
        setIsModalClosing(true);
        setTimeout(() => {
            setSelectedDetail(null);
            setIsModalClosing(false);
        }, 120);
    };
    const buildMenuTree = (menuItems) => {
        if (!Array.isArray(menuItems)) return [];
        const menuMap = {};
        const roots = [];
        menuItems.forEach(item => { if (item.Id != null) menuMap[item.Id] = { ...item, children: [] }; });
        menuItems.forEach(item => {
            if (item.Id == null) return;
            const parentId = item.Parentmenuid;
            if (parentId && menuMap[parentId]) menuMap[parentId].children.push(menuMap[item.Id]);
            else roots.push(menuMap[item.Id]);
        });
        return roots;
    };
    const menuTree = buildMenuTree(user?.menus || []);
    // ── modal content (admin only) ────────────────────────────────────────────
    const getModalContent = () => {
        switch (selectedDetail) {
            case 'users':
                return {
                    title: 'User Summary',
                    subtitle: 'Overview of registered users',
                    items: currentUsers.map(u => ({
                        name: u.nameOfCompany,
                        contact: u.contactNumber,
                        date: new Date(u.createDate).toLocaleDateString()
                    }))
                };
            case 'approvals':
                return {
                    title: 'Vendors Pending Final Approval',
                    subtitle: 'Vendors currently awaiting final approval',
                    items: currentApprovals.map(v => ({
                        name: v.companyName,
                        date: new Date(v.createdDate).toLocaleDateString()
                    }))
                };
            case 'vendors':
                return {
                    title: 'Registered Vendors',
                    subtitle: 'All vendors currently registered',
                    items: []
                };
            case 'invoicePending':
                return {
                    title: 'Invoices Pending Approval',
                    subtitle: 'Invoices currently awaiting approval',
                    items: currentInvoicesperUser && currentInvoicesperUser.length > 0
                        ? currentInvoicesperUser.map(i => ({
                            invoiceNo: i.invoiceNo,
                            date: new Date(i.createdDate).toLocaleDateString()
                        }))
                        : []
                };
            case 'totalCreated':
                return {
                    title: 'Total Invoices Created',
                    subtitle: 'All invoices you have submitted',
                    items: currentMyInvoices.map(inv => ({
                        invoiceNo: inv.invoiceNo,
                        date: inv.createdDate ? new Date(inv.createdDate).toLocaleDateString() : '-'
                    }))
                };
            case 'approvedInvoices':
                return {
                    title: 'Approved Invoices',
                    subtitle: 'Approved & ready for payment',
                    items: currentMyApproved.map(inv => ({
                        invoiceNo: inv.invoiceNo,
                        date: inv.createdDate ? new Date(inv.createdDate).toLocaleDateString() : '-'
                    }))
                };
            default: return { title: '', subtitle: '', items: [] };
        }
    };
    const indexOfLastInvoice = invoicePage * invoicesPerPage;
    const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
    const currentInvoicesperUser = isVendor
        ? pendingInvoicesperUser.slice(indexOfFirstInvoice, indexOfLastInvoice)
        : pendingInvoicesAdmin.slice(indexOfFirstInvoice, indexOfLastInvoice);
    const currentInvoices =
        pendingInvoices.slice(indexOfFirstInvoice, indexOfLastInvoice);
    const totalInvoicePages = Math.ceil(
        (isVendor ? pendingInvoicesperUser.length : pendingInvoicesAdmin.length) / invoicesPerPage
    );
    const indexOfLastApproval = approvalPage * approvalsPerPage;
    const indexOfFirstApproval = indexOfLastApproval - approvalsPerPage;
    const currentApprovals =
        pendingVendors.slice(indexOfFirstApproval, indexOfLastApproval);
    const totalApprovalPages = Math.ceil(
        pendingVendors.length / approvalsPerPage
    );
    /* USERS PAGINATION */
    const indexOfLastUser = usersPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers =
        usersList.slice(indexOfFirstUser, indexOfLastUser);
    const totalUsersPages = Math.ceil(
        usersList.length / usersPerPage
    );
    /* VENDORS PAGINATION */
    const indexOfLastVendor = vendorsPage * vendorsPerPage;
    const indexOfFirstVendor = indexOfLastVendor - vendorsPerPage;
    const currentVendors =
        vendorList.slice(indexOfFirstVendor, indexOfLastVendor);
    const totalVendorPages = Math.ceil(
        vendorList.length / vendorsPerPage
    );

    /* MY INVOICES (vendor) PAGINATION */
    const indexOfLastMyInvoice = myInvoicesPage * myInvoicesPerPage;
    const indexOfFirstMyInvoice = indexOfLastMyInvoice - myInvoicesPerPage;
    const currentMyInvoices = vendorInvoiceList.slice(indexOfFirstMyInvoice, indexOfLastMyInvoice);
    const totalMyInvoicesPages = Math.ceil(vendorInvoiceList.length / myInvoicesPerPage);

    /* MY APPROVED INVOICES (vendor) PAGINATION */
    const myApprovedInvoiceList = vendorInvoiceList.filter(inv => APPROVED_STATUSES.includes(inv.approvalStatus));
    const indexOfLastMyApproved = myApprovedPage * myInvoicesPerPage;
    const indexOfFirstMyApproved = indexOfLastMyApproved - myInvoicesPerPage;
    const currentMyApproved = myApprovedInvoiceList.slice(indexOfFirstMyApproved, indexOfLastMyApproved);
    const totalMyApprovedPages = Math.ceil(myApprovedInvoiceList.length / myInvoicesPerPage);
    const modalData = getModalContent();
    // ── shared chart configs ──────────────────────────────────────────────────
    const chartOptions = {
        chart: {
            type: 'area',
            height: 350,
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 900
            },
            toolbar: { show: false },
            zoom: { enabled: false },
            redrawOnParentResize: true,
            redrawOnWindowResize: true
        },
        colors: ['#3b82f6'],
        stroke: { curve: 'smooth', width: 3 },
        fill: { type: 'gradient', gradient: { shadeIntensity: 0.9, opacityFrom: 0.65, opacityTo: 0.15 } },
        dataLabels: { enabled: false },
        tooltip: { y: { formatter: val => `${Math.round(val)} vendors` } },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        yaxis: { min: 0, max: 50, title: { text: 'Vendors' } },
        grid: { borderColor: '#e2e8f0', strokeDashArray: 4 },
    };
    const chartSeries = [
        {
            name: 'Vendor Activity',
            data: Array.isArray(vendorChartData)
                ? vendorChartData
                : Array(12).fill(0)
        }
    ];
    const invoiceBarOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 }
        },
        colors: ['#2563eb', '#f59e0b', '#ef4444', '#0ea5e9'],
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                borderRadius: 4
            }
        },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 1, colors: ['transparent'] },
        xaxis: {
            categories: invoiceCategories
        },
        yaxis: {
            title: {
                text: 'Invoice Count',
                style: { color: darkMode ? '#e2e8f0' : '#64748b' }
            }
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: (val) => {
                    if (val === undefined || val === null) return "0";
                    return `${val} invoices`;
                }
            }
        },
        legend: {
            position: 'top',
            horizontalAlign: 'center'
        },
        grid: {
            borderColor: darkMode ? '#334155' : '#e2e8f0',
            strokeDashArray: 4
        }
    };
    const invoiceBarSeries = [
        {
            name: 'Approved Invoices',
            data: invoiceSeries[0]?.data || Array(6).fill(0)
        },
        {
            name: 'Pending Invoices',
            data: invoiceSeries[1]?.data || Array(6).fill(0)
        }
    ];
    //------Menu Icons --------------------------------------------------------------
    const menuIcons = {
        //vendors: '🏪',
        //'create invoice': '📄',
        //'view all invoice': '📋',
        //dashboard: '⊞',
        default: '◈',
    };
    const getIcon = (name = '') => menuIcons[name.toLowerCase()] ?? menuIcons.default;
    // ── admin card config ─────────────────────────────────────────────────────
    const prevStats = { totalVendors: 0, totalUsers: 0, pendingApprovals: 0, recentOrders: 0 };
    const calculateChange = (curr, prev) => prev === 0 ? 0 : ((curr - prev) / prev * 100).toFixed(1);
    const currentPath = location.pathname.toLowerCase(); // normalize path

    // Vendors are greeted by their own name/company; internal users by their role.
    // (The greeting word + live date/time are rendered by AppLayout's header.)
    const vendorDisplayName =
        vendorCompany ||
        user?.NameOfCompany || user?.nameOfCompany ||
        user?.vendorName || user?.VendorName ||
        user?.contactPersonName || user?.contactPerson ||
        'Vendor';

   const roleName = isVendor
? vendorDisplayName
: (user?.roles?.length
    ? user.roles.map(r => r.role).join(' / ')
            : (user?.contactPersonName || 'Team'));
    const hideCharts = roleName === "Finance Team / Verifier";

    if (!user) return <div>Loading...</div>;
    return (
        <>
            {/* Main container — unchanged */}
            <AppLayout titleAccent={roleName}>
                {/* ── MAIN CONTENT: swapped based on role ── */}
                <div className="dashboard-content-wrapper">
                    {isVendor ? (
                        /* ══════════════════════════════════════════════
                           VENDOR CONTENT
                           ══════════════════════════════════════════════ */
                        <>
                            {/* Vendor portal — KPI hero cards only (no charts) */}
                            <div className="vendor-kpi-grid">
                                {[
                                    {
                                        key: 'total', accent: 'blue', eyebrow: 'Lifetime',
                                        title: 'Total Invoices Created', value: vendorStats.totalCreated,
                                        caption: 'All invoices you have submitted', type: 'totalCreated',
                                        icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>),
                                    },
                                    {
                                        key: 'approved', accent: 'sky', eyebrow: 'Cleared',
                                        title: 'Approved Invoices', value: vendorStats.approved,
                                        caption: 'Approved & ready for payment', type: 'approvedInvoices',
                                        icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>),
                                    },
                                    {
                                        key: 'pending', accent: 'amber', eyebrow: 'In review',
                                        title: 'Invoices Pending Approval', value: pendingInvoices.length,
                                        caption: 'Currently awaiting approval', type: 'invoicePending',
                                        icon: (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>),
                                    },
                                ].map((item, i) => (
                                    <div
                                        key={item.key}
                                        className={`vendor-kpi-card kpi-${item.accent} ${item.type ? 'is-clickable' : ''}`}
                                        style={{ animationDelay: `${i * 0.12}s` }}
                                        onClick={() => item.type && handleCardClick(item.type)}
                                    >
                                        <span className="vendor-kpi-watermark" aria-hidden="true">{item.icon}</span>
                                        <span className="vendor-kpi-glow" aria-hidden="true" />
                                        <div className="vendor-kpi-top">
                                            <span className="vendor-kpi-icon">{item.icon}</span>
                                            <span className="vendor-kpi-eyebrow">{item.eyebrow}</span>
                                        </div>
                                        {loading ? (
                                            <div className="skeleton" style={{ margin: '22px 0 0', height: '60px', width: '120px' }} />
                                        ) : (
                                            <div className="vendor-kpi-value"><CountUp end={item.value} duration={1.8} separator="," /></div>
                                        )}
                                        <h4 className="vendor-kpi-title">{item.title}</h4>
                                        <div className="vendor-kpi-foot"><span className="vendor-kpi-dot" />{item.caption}</div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        /* ══════════════════════════════════════════════
                           ADMIN / INTERNAL USER CONTENT  — unchanged
                           ══════════════════════════════════════════════ */

                        <>
                                <div className="unified-stats-card" style={{ display: 'flex', background: darkMode ? '#1e1e2f' : '#fff', borderRadius: '4px', border: darkMode ? '1px solid #334155' : '1px solid #1e1e1e', overflow: 'hidden', padding: 0, margin: 0, boxShadow: 'none' }}>                                {[
                                    { eyebrow: '01 / USERS', title: 'Total Number of Users', value: stats.totalUsers, color: '#3b82f6', type: 'users', prev: prevStats.totalUsers, pos: true },
                                    { eyebrow: '02 / VENDORS', title: 'Total Registered Vendors', value: stats.totalVendors, color: '#3b82f6', type: 'vendors', prev: prevStats.totalVendors, pos: true },
                                    { eyebrow: '03 / PENDING', title: 'Vendors Pending Approval', value: pendingVendors.length, color: '#3b82f6', type: 'approvals', prev: prevStats.pendingApprovals, pos: true },
                                    { eyebrow: '04 / INVOICES', title: 'Invoices Pending Approval', value: stats.InvoicesPendingApproval, color: '#dc2626', type: 'invoicePending', prev: prevStats.recentOrders, pos: false, last: true },
                                ].map((item, i) => {
                                    const change = calculateChange(item.value, item.prev);
                                    return (
                                        <div
                                            key={item.eyebrow}
                                            className="stat-col clickable"
                                            onClick={() => handleCardClick(item.type)}
                                            style={{ flex: 1, padding: '24px', borderRight: item.last ? 'none' : (darkMode ? '1px solid #334155' : '1px solid #1e1e1e'), borderBottom: item.last ? '4px solid #dc2626' : '4px solid #3b82f6', display: 'flex', flexDirection: 'column', gap: '8px', cursor: 'pointer' }}                                        >
                                            <div style={{ fontSize: '11px', color: darkMode ? '#94a3b8' : '#666', letterSpacing: '1px' }}>{item.eyebrow}</div>
                                            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: darkMode ? '#e2e8f0' : '#1a1a1a' }}>{item.title}</h4>
                                            {loading ? (
                                                <div className="skeleton" style={{ marginTop: '8px' }} />
                                            ) : (
                                                <>
                                                    <div className="stat-number" style={{ color: item.color, fontSize: '4.5rem', fontWeight: 400, lineHeight: 1.1, marginTop: '8px', fontFamily: 'serif' }}>
                                                        <CountUp end={item.value} duration={1.8} separator="," />
                                                    </div>
                                                    <div style={{ color: item.pos ? '#3b82f6' : '#dc2626', fontSize: '11px', fontWeight: 700, marginTop: 'auto', paddingTop: '16px' }}>
                                                        {item.pos ? '▲' : '▼'} {item.last ? '100% cleared' : `${Math.abs(change)}% YoY`}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                                </div>
                                {!hideCharts && (
                                    <div className="charts-row" style={{ display: 'flex', gap: '24px', marginTop: '24px' }}>
                                        <div className="card chart-card premium-card" style={{ flex: 1, padding: '24px', border: darkMode ? '1px solid #334155' : '1px solid #1e1e1e', borderRadius: '4px', boxShadow: 'none' }}>
                                            <div className="chart-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                                                <div>
                                                    <h3 style={{ margin: 0, fontSize: '1.5rem', color: darkMode ? '#e2e8f0' : '#1a1a1a', fontWeight: 400, fontFamily: 'serif' }}>Vendor Activity</h3>
                                                    <p style={{ margin: '4px 0 0', fontSize: '14px', fontStyle: 'italic', color: darkMode ? '#94a3b8' : '#666', fontFamily: 'serif' }}>New registrations through the year</p>
                                                </div>
                                                <span style={{ color: '#3b82f6', fontWeight: 600, fontSize: '11px', letterSpacing: '1px' }}>● LIVE</span>
                                            </div>
                                            <ReactApexChart options={{ ...chartOptions, colors: ['#3b82f6'], fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.3, opacityTo: 0, stops: [0, 100] } }, grid: { borderColor: '#e2e8f0', strokeDashArray: 0 } }} series={chartSeries} type="area" height={280} />
                                        </div>
                                        <div className="card chart-card premium-card" style={{ flex: 1, padding: '24px', border: '1px solid #1e1e1e', borderRadius: '4px', boxShadow: 'none' }}>
                                            <div className="chart-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                                                <div>
                                                    <h3 style={{ margin: 0, fontSize: '1.5rem', color: '#1a1a1a', fontWeight: 400, fontFamily: 'serif' }}>Invoice Details</h3>
                                                    <p style={{ margin: '4px 0 0', fontSize: '14px', fontStyle: 'italic', color: '#666', fontFamily: 'serif' }}>Approved against pending, monthly</p>
                                                </div>
                                                <span style={{ color: '#3b82f6', fontWeight: 600, fontSize: '11px', letterSpacing: '1px' }}>● LIVE</span>
                                            </div>
                                            <ReactApexChart options={{ ...invoiceBarOptions, colors: ['#3b82f6', '#b48347'], plotOptions: { bar: { columnWidth: '15%', borderRadius: 0 } }, grid: { borderColor: '#e2e8f0', strokeDashArray: 0 } }} series={invoiceBarSeries} type="bar" height={280} />
                                        </div>
                                    </div>
                                )}
                        </>
                    )}
                </div>
            </AppLayout>
            {/* Modal — admin only, vendor has no selectedDetail trigger */}
            {selectedDetail && (
                <div
                    className={`modal-overlay${isModalClosing ? ' is-closing' : ''}`}
                    onClick={closeModal}
                    role="presentation"
                >
                    <div
                        className={`modal-content${isModalClosing ? ' is-closing' : ''}`}
                        onClick={e => e.stopPropagation()}
                        ref={modalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="vms-modal-title"
                        aria-describedby="vms-modal-subtitle"
                    >
                        <div className="modal-header">
                            <div className="modal-heading">
                                <h2 id="vms-modal-title" className="modal-title">{modalData.title}</h2>
                                {modalData.subtitle && (
                                    <p id="vms-modal-subtitle" className="modal-subtitle">{modalData.subtitle}</p>
                                )}
                            </div>
                            <button
                                className="close-btn"
                                onClick={closeModal}
                                aria-label="Close dialog"
                                type="button"
                            >
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                </svg>
                            </button>
                        </div>
                        <div className="modal-body">
                            {/*{modalData.items.length > 0 ? (*/}
                            {selectedDetail === 'vendors' ||
                                modalData.items.length > 0 ? (
                                <>
                                    <table className="detail-table">
                                        <thead>
                                            <tr>
                                                {selectedDetail === 'vendors' && (
                                                    <>
                                                        <th>Vendor Code</th>
                                                        <th>Vendor Name</th>
                                                        <th>Contact Person</th>
                                                    </>
                                                )}
                                                {selectedDetail === 'users' && (
                                                    <>
                                                        <th>Company</th>
                                                        <th>Contact</th>
                                                        <th>Created Date</th>
                                                    </>
                                                )}
                                                {selectedDetail === 'approvals' && (
                                                    <>
                                                        <th>Company</th>
                                                        <th>Created Date</th>
                                                    </>
                                                )}
                                                {selectedDetail === 'invoicePending' && (
                                                    <>
                                                        <th>Invoice No</th>
                                                        <th>Created Date</th>
                                                    </>
                                                    )}
                                                    {(selectedDetail === 'totalCreated' || selectedDetail === 'approvedInvoices') && (
                                                        <>
                                                            <th>Invoice No</th>
                                                            <th>Created Date</th>
                                                        </>
                                                    )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedDetail === 'vendors' ? (
                                                vendorLoading ? (
                                                    <tr>
                                                        <td colSpan="3">Loading...</td>
                                                    </tr>
                                                ) : vendorList.length > 0 ? (
                                                    currentVendors.map((v, idx) => (
                                                        <tr key={idx}>
                                                            <td>{v.vendorCode || '-'}</td>
                                                            <td>{v.legalName || '-'}</td>
                                                            <td>{v.contactPersonName || '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3">No vendors found</td>
                                                    </tr>
                                                )
                                            ) : selectedDetail === 'users' ? (
                                                modalData.items.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>{row.name || '-'}</td>
                                                        <td>{row.contact || '-'}</td>
                                                        <td>{row.date || '-'}</td>
                                                    </tr>
                                                ))
                                            ) : selectedDetail === 'approvals' ? (
                                                modalData.items.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>{row.name || '-'}</td>
                                                        <td>{row.date || '-'}</td>
                                                    </tr>
                                                ))
                                            ) : selectedDetail === 'invoicePending' ? (
                                                modalData.items.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>{row.invoiceNo || '-'}</td>
                                                        <td>{row.date || '-'}</td>
                                                    </tr>
                                                ))                                                            
                                            ) : (selectedDetail === 'totalCreated' || selectedDetail === 'approvedInvoices') ? (
                     modalData.items.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{row.invoiceNo || '-'}</td>
                                                    <td>{row.date || '-'}</td>
                                                </tr>
                                                ))
                                                )
                                                : null}
                                        </tbody>
                                    </table>
                                    {selectedDetail === 'invoicePending' &&
                                        totalInvoicePages > 1 && (() => {
                                            const pagesPerGroup = 10;
                                            const currentGroup = Math.ceil(invoicePage / pagesPerGroup);
                                            const startPage = (currentGroup - 1) * pagesPerGroup + 1;
                                            const endPage = Math.min(
                                                startPage + pagesPerGroup - 1,
                                                totalInvoicePages
                                            );
                                            return (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginTop: '20px',
                                                        gap: '8px',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    {/* PREVIOUS */}
                                                    <button
                                                        disabled={invoicePage === 1}
                                                        onClick={() => setInvoicePage(invoicePage - 1)}
                                                        style={{
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ccc',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Prev
                                                    </button>
                                                    {/* PAGE NUMBERS */}
                                                    {Array.from(
                                                        { length: endPage - startPage + 1 },
                                                        (_, index) => {
                                                            const pageNumber = startPage + index;
                                                            return (
                                                                <button
                                                                    key={pageNumber}
                                                                    onClick={() => setInvoicePage(pageNumber)}
                                                                    style={{
                                                                        padding: '6px 12px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ccc',
                                                                        background:
                                                                            invoicePage === pageNumber
                                                                                ? '#2563eb'
                                                                                : '#fff',
                                                                        color:
                                                                            invoicePage === pageNumber
                                                                                ? '#fff'
                                                                                : '#000',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {pageNumber}
                                                                </button>
                                                            );
                                                        }
                                                    )}
                                                    {/* NEXT */}
                                                    <button
                                                        disabled={invoicePage === totalInvoicePages}
                                                        onClick={() => setInvoicePage(invoicePage + 1)}
                                                        style={{
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ccc',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            );
                                        })()}
                                    {selectedDetail === 'approvals' &&
                                        totalApprovalPages > 1 && (() => {
                                            const pageGroup = Math.floor((approvalPage - 1) / 10);
                                            const startPage = pageGroup * 10 + 1;
                                            const endPage = Math.min(startPage + 9, totalApprovalPages);
                                            return (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        gap: '8px',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    {/* PREV */}
                                                    <button
                                                        onClick={() =>
                                                            setApprovalPage(prev => Math.max(prev - 1, 1))
                                                        }
                                                        disabled={approvalPage === 1}
                                                    >
                                                        Prev
                                                    </button>
                                                    {/* PAGE NUMBERS */}
                                                    {Array.from(
                                                        { length: endPage - startPage + 1 },
                                                        (_, index) => {
                                                            const page = startPage + index;
                                                            return (
                                                                <button
                                                                    key={page}
                                                                    onClick={() => setApprovalPage(page)}
                                                                    style={{
                                                                        padding: '6px 12px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ccc',
                                                                        background:
                                                                            approvalPage === page
                                                                                ? '#2563eb'
                                                                                : '#fff',
                                                                        color:
                                                                            approvalPage === page
                                                                                ? '#fff'
                                                                                : '#000',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {page}
                                                                </button>
                                                            );
                                                        }
                                                    )}
                                                    {/* NEXT */}
                                                    <button
                                                        onClick={() =>
                                                            setApprovalPage(prev =>
                                                                Math.min(prev + 1, totalApprovalPages)
                                                            )
                                                        }
                                                        disabled={approvalPage === totalApprovalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            );
                                        })()}
                                    {selectedDetail === 'users' &&
                                        totalUsersPages > 1 && (() => {
                                            const pageGroup = Math.floor((usersPage - 1) / 10);
                                            const startPage = pageGroup * 10 + 1;
                                            const endPage = Math.min(startPage + 9, totalUsersPages);
                                            return (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        gap: '8px',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <button
                                                        onClick={() =>
                                                            setUsersPage(prev => Math.max(prev - 1, 1))
                                                        }
                                                        disabled={usersPage === 1}
                                                    >
                                                        Prev
                                                    </button>
                                                    {Array.from(
                                                        { length: endPage - startPage + 1 },
                                                        (_, index) => {
                                                            const page = startPage + index;
                                                            return (
                                                                <button
                                                                    key={page}
                                                                    onClick={() => setUsersPage(page)}
                                                                    style={{
                                                                        padding: '6px 12px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ccc',
                                                                        background:
                                                                            usersPage === page
                                                                                ? '#2563eb'
                                                                                : '#fff',
                                                                        color:
                                                                            usersPage === page
                                                                                ? '#fff'
                                                                                : '#000',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {page}
                                                                </button>
                                                            );
                                                        }
                                                    )}
                                                    <button
                                                        onClick={() =>
                                                            setUsersPage(prev =>
                                                                Math.min(prev + 1, totalUsersPages)
                                                            )
                                                        }
                                                        disabled={usersPage === totalUsersPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            );
                                        })()}
                                    {selectedDetail === 'vendors' &&
                                        totalVendorPages > 1 && (() => {
                                            const pageGroup = Math.floor((vendorsPage - 1) / 10);
                                            const startPage = pageGroup * 10 + 1;
                                            const endPage = Math.min(startPage + 9, totalVendorPages);
                                            return (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        gap: '8px',
                                                        flexWrap: 'wrap'
                                                    }}
                                                >
                                                    <button
                                                        onClick={() =>
                                                            setVendorsPage(prev => Math.max(prev - 1, 1))
                                                        }
                                                        disabled={vendorsPage === 1}
                                                    >
                                                        Prev
                                                    </button>
                                                    {Array.from(
                                                        { length: endPage - startPage + 1 },
                                                        (_, index) => {
                                                            const page = startPage + index;
                                                            return (
                                                                <button
                                                                    key={page}
                                                                    onClick={() => setVendorsPage(page)}
                                                                    style={{
                                                                        padding: '6px 12px',
                                                                        borderRadius: '6px',
                                                                        border: '1px solid #ccc',
                                                                        background:
                                                                            vendorsPage === page
                                                                                ? '#2563eb'
                                                                                : '#fff',
                                                                        color:
                                                                            vendorsPage === page
                                                                                ? '#fff'
                                                                                : '#000',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    {page}
                                                                </button>
                                                            );
                                                        }
                                                    )}
                                                    <button
                                                        onClick={() =>
                                                            setVendorsPage(prev =>
                                                                Math.min(prev + 1, totalVendorPages)
                                                            )
                                                        }
                                                        disabled={vendorsPage === totalVendorPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            );
                                            })()}
                                        {selectedDetail === 'totalCreated' && totalMyInvoicesPages > 1 && (
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '8px' }}>
                                                <button
                                                    onClick={() => setMyInvoicesPage(p => Math.max(p - 1, 1))}
                                                    disabled={myInvoicesPage === 1}
                                                    style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc', cursor: 'pointer' }}
                                                >
                                                    Prev
                                                </button>
                                                {Array.from({ length: totalMyInvoicesPages }, (_, i) => i + 1).map(page => (
                                                    <button
                                                        key={page}
                                                        onClick={() => setMyInvoicesPage(page)}
                                                        style={{
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ccc',
                                                            background: myInvoicesPage === page ? '#2563eb' : '#fff',
                                                            color: myInvoicesPage === page ? '#fff' : '#000',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        {page}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setMyInvoicesPage(p => Math.min(p + 1, totalMyInvoicesPages))}
                                                    disabled={myInvoicesPage === totalMyInvoicesPages}
                                                    style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc', cursor: 'pointer' }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        )}
                                        {selectedDetail === 'approvedInvoices' && totalMyApprovedPages > 1 && (
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '8px' }}>
                                                <button
                                                    onClick={() => setMyApprovedPage(p => Math.max(p - 1, 1))}
                                                    disabled={myApprovedPage === 1}
                                                    style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc', cursor: 'pointer' }}
                                                >
                                                    Prev
                                                </button>
                                                {Array.from({ length: totalMyApprovedPages }, (_, i) => i + 1).map(page => (
                                                    <button
                                                        key={page}
                                                        onClick={() => setMyApprovedPage(page)}
                                                        style={{
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            border: '1px solid #ccc',
                                                            background: myApprovedPage === page ? '#2563eb' : '#fff',
                                                            color: myApprovedPage === page ? '#fff' : '#000',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        {page}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setMyApprovedPage(p => Math.min(p + 1, totalMyApprovedPages))}
                                                    disabled={myApprovedPage === totalMyApprovedPages}
                                                    style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc', cursor: 'pointer' }}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        )}
                                    </>                                
                            ) : (
                                <div className="modal-empty-state">
                                    <div className="empty-state-icon" aria-hidden="true">
                                        <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                            <polyline points="14 2 14 8 20 8" />
                                            <line x1="8" y1="13" x2="16" y2="13" />
                                            <line x1="8" y1="17" x2="13" y2="17" />
                                        </svg>
                                    </div>
                                    <h3 className="empty-state-title">
                                        {selectedDetail === 'invoicePending'
                                            ? 'No Pending Approvals'
                                            : 'Nothing to show'}
                                    </h3>
                                    <p className="empty-state-text">
                                        {selectedDetail === 'invoicePending'
                                            ? 'There are currently no invoices awaiting approval.'
                                            : 'There is no data available right now.'}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={closeModal}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
export default MasterPage;